export default __webpack_public_path__ + "static/media/emptyOverviewView.5b0e1f0b.svg";